import type { PointsHistory } from '../../types';
import type { Language } from '../../i18n';
import { useTranslation } from '../../hooks/useTranslation';
import CashbackIcon from '../CashbackIcon';

interface HistoryTabProps {
  pointsHistory: PointsHistory[];
  language: Language;
  formatPoints: (points: number) => string;
  noHistoryText: string;
}

const HistoryTab = ({ pointsHistory, formatPoints, noHistoryText }: HistoryTabProps) => {
  const { t } = useTranslation();
  return (
    <div className="space-y-3">
      <h3 className="text-base font-semibold text-white mb-3">
        {t('checkIn.rewardHistory')}
      </h3>
      {pointsHistory.length > 0 ? (
        pointsHistory.map((history) => (
          <div key={history.id} className="bg-tg-secondary rounded-lg p-3 flex justify-between items-center border border-gray-800 hover:border-primary/50 hover:bg-[#2a2a2a] hover:scale-[1.02] hover:shadow-lg hover:shadow-primary/10 transition-all duration-300 cursor-pointer">
            <div className="flex-1">
              <div className="text-sm text-white mb-1">{history.description}</div>
              <div className="text-xs text-tg-hint">
                {new Date(history.createdAt).toLocaleDateString()}
              </div>
            </div>
            <div className={`flex items-center gap-1 text-base font-semibold ${
              history.points > 0 ? 'text-primary' : 'text-red-400'
            }`}>
              <CashbackIcon size={18} />
              <span>{history.points > 0 ? '+' : ''}{formatPoints(Math.abs(history.points))} {t('checkIn.points')}</span>
            </div>
          </div>
        ))
      ) : (
        <div className="text-center py-12 text-tg-hint">{noHistoryText}</div>
      )}
    </div>
  );
};

export default HistoryTab;

